import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { showPausedCampaignNotifications } from '@bingads-webui-campaign/import-shared-utils';
import { renderStatusPopupEditor } from '@bingads-webui-campaign/status-popup-editor';
import { TargetingSettingsContext } from '@bingads-webui-campaign/targeting-settings-scaffolds';
import statusTemplate from './status-column.pug';
import headerTemplate from './status-column-header.pug';
import { inlineEditableSave } from './inline-editable/save';

const templateConfig = {
  UserPaused: {
    statusText: 'Paused',
    ariaLabel: 'EntityStatus_Paused',
    classes: 'statusPaused_icon',
  },
  BudgetUserPaused: {
    statusText: 'Paused',
    ariaLabel: 'EntityStatus_Paused',
    classes: 'statusPaused_icon',
  },
  Deleted: {
    statusText: 'Deleted',
    ariaLabel: 'EntityStatus_Deleted',
    classes: 'statusDeleted_icon',
  },
  Suspended: {
    statusText: 'Suspended',
    ariaLabel: 'EntityStatus_Suspended',
    classes: 'statusSuspended_icon',
  },
};

const defaultTemplateConfig = {
  statusText: 'Enabled',
  ariaLabel: 'EntityStatus_Active',
  classes: 'statusEnabled_icon',
};

function getStatusTemplateConfig(status, isExperiment) {
  const config = _.clone(_.result(templateConfig, status, defaultTemplateConfig));

  if (isExperiment) {
    config.classes = _.result({
      Enabled: 'experiment-active-icon',
      Paused: 'experiment-paused-icon',
    }, config.statusText, config.classes);
  }

  return config;
}

export class ColumnStatus extends CampaignuiBaseColumn {
  constructor({ i18n, view }) {
    super({
      name: 'Status',
      property: ['Status', 'Id', 'ExperimentId', 'ImportProperties'],
      title: 'ColumnName_Status',
      sortable: 'Status',
      type: 'string',
      headerTemplate: () => headerTemplate({}),
      i18n,
    });

    this.i18n = i18n;
    this.view = view;
  }

  pickProperty(item) {
    const {
      Status,
      Id,
      ExperimentId,
    } = item;

    return {
      Status,
      Id,
      ExperimentId,
    };
  }

  template({ value }) {
    return statusTemplate(_.extend(
      { i18n: this.i18n },
      value,
      getStatusTemplateConfig(value.Status, !!value.ExperimentId)
    ));
  }

  onPrompt({ item, newPosition }) {
    const statusEditor = renderStatusPopupEditor({
      position: newPosition,
      i18n: this.i18n,
      currentStatus: item.Status,
      isForVNext: true,
      statusOptions: (() => {
        let options = [
          { name: 'Enabled', value: 'Active' },
          { name: 'Paused', value: 'UserPaused' },
        ];
        const isExperiment = _.result(item, 'ExperimentId');

        if (isExperiment) {
          options = _.map(options, (option) => {
            const iconClass = _.result({
              Enabled: 'experiment-active-icon',
              Paused: 'experiment-paused-icon',
            }, option.name);

            return _.defaults({ iconClass }, option);
          });
        }

        return options;
      })(),
    });
    const { activity: pausedCampaignImportNotificationActivity } = this.view.instrumentation.createScenarioAndActivity({
      scenarioName: 'PausedCampaignImportNotification',
      activityName: 'SettingsGridStatusColumn',
    });
    statusEditor.then((status) => {
      if (status && status !== item.Status) {
        // workaround to fix the bug in bulkupsert api.
        // use 'UserPaused' will get success but actually the request take No effect.
        const updated = _.defaults({ Status: status === 'UserPaused' ? 'Paused' : status }, item);
        inlineEditableSave({
          view: this.view,
          i18n: this.i18n,
          fieldName: 'Status',
          updated,
          editorViewCallbackAfterUpdate: () => {
            const schema = TargetingSettingsContext.campaignStatus;
            const response = [{
              Id: item.Id,
              Status: status === schema.Paused ? schema.EnumPaused : status,
            }];
            window.App.trigger('campaignUpdated', { data: response });
            updated.Status = status; // revert the workaround above
          },
          importNotificationCallback: () => {
            // show paused campaign notifications based on specific conditions
            showPausedCampaignNotifications({ campaignItemList: [item], updateStatus: status, activity: pausedCampaignImportNotificationActivity });
          },
        });
      }
    });
  }
}
